import { useTranslation } from 'react-i18next';
import { ILoadHistoryEventResponse } from '../../../../interfaces/ILoadHistoryResponse';
import { formatDateTime } from '../../../../../../../utils/date-utils';

function HistoryItemUnsuspended({
    history,
}: Readonly<{ history: ILoadHistoryEventResponse }>) {
    const { t } = useTranslation();
    return (
        <div
            className="load-history-event-container load-history-line"
            data-testid="load-history-event"
        >
            <div className="load-history-section-title">
                <h4 className="load-history-event-type">
                    {t('LoadHistory.Events.Unsuspended')}
                </h4>
            </div>
            <span>
                {formatDateTime(history.eventDate)}
            </span>
            <span>
                {t('LoadHistory.Reasons.UnsuspendedDescription')}
            </span>
        </div>
    );
}

export default HistoryItemUnsuspended; 